<template>
    <div>
        <v-btn
            size="small"
            elevation="0"
            class="mx-1"
            rounded
            color="ternary"
            @click="openDialog()"
        >
            <v-icon size="large" left class="pr-2">$fa-plus</v-icon> une activité
        </v-btn>
        <oss-dialog v-model="dialog" title="Ajouter une activité" @valid="closeDialog" width="40vw">
            <div class="pt-2" style="width: 100%">
                <v-text-field-filled
                    label="Rechercher"
                    v-model="searchActivity"
                    outlined
                    density="compact"
                    class="mb-3"
                />
                <v-virtual-scroll
                    :benched="20"
                    :items="filteredActivitiesList"
                    height="500"
                    item-height="64"
                >
                    <template v-slot:default="{ item }">
                        <v-list-item
                            :key="item.id"
                            class="d-flex align-center mb-1"
                            border="sm"
                            variant="outlined"
                            rounded="xl"
                            density="comfortable"
                            style="height: 60px"
                        >
                            <template v-slot:prepend>
                                <v-checkbox-btn
                                    density="comfortable"
                                    :model-value="isSelectedActivities(item.id)"
                                    @update:model-value="selectActivities(item)"
                                    color="primary"
                                    class="pr-3 pa-0"
                                />
                            </template>
                            {{ item.name }} - {{ item.description }}
                        </v-list-item>
                    </template>
                </v-virtual-scroll>
            </div>
        </oss-dialog>
    </div>
</template>

<script lang="ts">
import CompanyTable from "../admin/CompaniesTable.vue";
import { Apollo } from "@/decorators";
import COMPANY_ACTIVITIES from "@/graphql/CompanyActivities.gql";
import { Component, Vue, toNative, Model } from "vue-facing-decorator";

@Component({
    components: {
        CompanyTable,
    },
})
export class ScopeActionsAddActivity extends Vue {
    @Model({ name: "activities" }) inputActivitiesSync!: any[];

    dialog: boolean = false;
    company = null;

    searchActivity: string = "";

    openDialog() {
        this.dialog = true;
    }

    get filteredActivitiesList() {
        let activitiesList = this.activitiesList.sort(
            (a: { name: string }, b: { name: string }) => {
                return a.name.localeCompare(b.name);
            },
        );
        if (this.searchActivity) {
            activitiesList = activitiesList.filter(
                (activity: { name: string; description: string }) => {
                    return (
                        activity.name.toLowerCase().indexOf(this.searchActivity.toLowerCase()) !==
                            -1 ||
                        activity.description
                            .toLowerCase()
                            .indexOf(this.searchActivity.toLowerCase()) !== -1
                    );
                },
            );
        }
        return activitiesList;
    }

    selectActivities(activities: { id: string; description: string; name: string }) {
        const isSelected = this.isSelectedActivities(activities.id);
        if (isSelected) {
            const activityIndex = this.inputActivitiesSync.findIndex((a) => a.id === activities.id);
            if (activityIndex !== -1) {
                this.inputActivitiesSync.splice(activityIndex, 1);
            }
        } else {
            this.inputActivitiesSync.push(activities);
        }
    }

    isSelectedActivities(activitiesId: string) {
        const isSelected = this.inputActivitiesSync.find((a) => a.id === activitiesId);
        return !!isSelected;
    }

    @Apollo(
        {
            query: COMPANY_ACTIVITIES,
        },
        (data) => {
            return data.companyActivities;
        },
    )
    activitiesList: { id: string; name: string; description: string }[] = [];

    checkboxValueComparator = (a: { id: string }, b: { id: string }) => {
        return a.id === b.id;
    };

    closeDialog() {
        this.dialog = false;
    }
}

export default toNative(ScopeActionsAddActivity);
</script>
